import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const VendingLarge = styled.svg`
  fill: none;
  width: 104px;
  height: 104px;
`;

const VendingLargeIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <VendingLarge
    {...props}
    ref={ref}
    viewBox="0 0 105 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.2179 73H66.209C66.7613 73 67.209 72.5523 67.209 72V54C67.209 53.4477 66.8453 53 66.293 53C65.8387 53 65.1754 53 64.211 53M26.0407 73C19.3865 73 11.0781 73 8.24751 73C7.69522 73 7.25 72.5523 7.25 72V54C7.25 53.4477 7.69772 53 8.25 53H32.2329"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="13.25"
      y1="79"
      x2="91.25"
      y2="79"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="32.25"
      y1="84"
      x2="72.25"
      y2="84"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M67.25 72.226V24.9761L75.25 17H91.25L97.25 21.9083V73"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.25 17V73H91.25"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="75.25"
      y1="31"
      x2="91.25"
      y2="31"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="75.25"
      y1="45"
      x2="91.25"
      y2="45"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="75.25"
      y1="59"
      x2="91.25"
      y2="59"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="47.9487" cy="46.3965" r="7" stroke="#00AED9" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.9481 72.2302L47.9482 72.23L47.9483 72.23L47.9494 72.2283L47.9551 72.2203L47.9794 72.1856C48.0013 72.1543 48.0346 72.1068 48.0783 72.0438C48.1658 71.9178 48.2954 71.7301 48.4611 71.4872C48.7925 71.0012 49.2679 70.2946 49.8393 69.4188C50.9831 67.6652 52.5056 65.2424 54.025 62.559C55.5479 59.8696 57.0485 56.9521 58.1631 54.2043C59.2971 51.4088 59.9487 48.9851 59.9487 47.22C59.9487 40.033 54.4768 34.4035 47.9609 34.3965C41.4636 34.4823 36.0318 40.0736 35.9487 47.2305C35.9513 48.9953 36.6029 51.4199 37.735 54.2174C38.8499 56.9727 40.3508 59.8997 41.8739 62.5986C43.3935 65.2915 44.9161 67.7237 46.0602 69.4843C46.6315 70.3636 47.107 71.0732 47.4385 71.5612C47.6042 71.8052 47.7338 71.9937 47.8214 72.1203C47.8651 72.1835 47.8984 72.2313 47.9203 72.2628L47.9227 72.2662L47.9481 72.2302ZM49.5821 73.3835C49.5821 73.3835 61.9487 55.8671 61.9487 47.22C61.9487 39.0332 55.6807 32.3965 47.9487 32.3965C40.2536 32.4899 34.037 39.0722 33.9487 47.22C33.9487 55.8671 46.3154 73.4577 46.3154 73.4577C46.7136 73.9966 47.305 74.3365 47.9487 74.3965C48.6098 74.3378 49.2103 73.9654 49.5821 73.3835Z"
      fill="#00AED9"
    />
    <mask id="path-11-inside-1_13130_37116" fill="white">
      <rect x="10.25" y="60" width="20" height="14" rx="1" />
    </mask>
    <rect
      x="10.25"
      y="60"
      width="20"
      height="14"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-11-inside-1_13130_37116)"
    />
    <path
      d="M42.25 73H34.25C33.6977 73 33.25 72.5523 33.25 72V62C33.25 61.4477 33.6977 61 34.25 61H36.25"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </VendingLarge>
));

export default VendingLargeIcon;
